var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiDetected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F21A34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9C5.5 9 5.5 8.17157 6.08579 7.58579C6.08579 7.58579 6.67157 7 7.5 7H16.5C16.5 7 17.3284 7 17.9142 7.58579C17.9142 7.58579 18.5 8.17157 18.5 9V16C18.5 16 18.5 16.8284 17.9142 17.4142C17.9142 17.4142 17.3284 18 16.5 18H7.5C7.5 18 6.67157 18 6.08579 17.4142C6.08579 17.4142 5.5 16.8284 5.5 16V9ZM6.5 9L6.5 16C6.5 16 6.5 16.4142 6.79289 16.7071C6.79289 16.7071 7.08579 17 7.5 17H16.5C16.5 17 16.9142 17 17.2071 16.7071C17.2071 16.7071 17.5 16.4142 17.5 16V9C17.5 9 17.5 8.58579 17.2071 8.29289C17.2071 8.29289 16.9142 8 16.5 8H7.5C7.5 8 7.08579 8 6.79289 8.29289C6.79289 8.29289 6.5 8.58579 6.5 9Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.25C8 14.25 8 13.5251 8.51256 13.0126C8.51256 13.0126 9.02513 12.5 9.75 12.5H14.25C14.25 12.5 14.9749 12.5 15.4874 13.0126C15.4874 13.0126 16 13.5251 16 14.25C16 14.25 16 14.9749 15.4874 15.4874C15.4874 15.4874 14.9749 16 14.25 16H9.75C9.75 16 9.02513 16 8.51256 15.4874C8.51256 15.4874 8 14.9749 8 14.25ZM9 14.25C9 14.25 9 14.5607 9.21967 14.7803C9.21967 14.7803 9.43934 15 9.75 15H14.25C14.25 15 14.5607 15 14.7803 14.7803C14.7803 14.7803 15 14.5607 15 14.25C15 14.25 15 13.9393 14.7803 13.7197C14.7803 13.7197 14.5607 13.5 14.25 13.5H9.75C9.75 13.5 9.43934 13.5 9.21967 13.7197C9.21967 13.7197 9 13.9393 9 14.25Z",
    fill: "#F8F8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13V15.5C12.75 15.7761 12.9739 16 13.25 16C13.5261 16 13.75 15.7761 13.75 15.5V13C13.75 12.7239 13.5261 12.5 13.25 12.5C12.9739 12.5 12.75 12.7239 12.75 13Z",
    fill: "#F8F8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13V15.5C10.25 15.7761 10.4739 16 10.75 16C11.0261 16 11.25 15.7761 11.25 15.5V13C11.25 12.7239 11.0261 12.5 10.75 12.5C10.4739 12.5 10.25 12.7239 10.25 13Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5V5C12.5 4.72386 12.2761 4.5 12 4.5C11.7239 4.5 11.5 4.72386 11.5 5V7.5C11.5 7.77614 11.7239 8 12 8C12.2761 8 12.5 7.77614 12.5 7.5Z",
    fill: "#F8F8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75C10 11.1642 9.66422 11.5 9.25 11.5C8.83578 11.5 8.5 11.1642 8.5 10.75C8.5 10.3358 8.83578 10 9.25 10C9.66422 10 10 10.3358 10 10.75Z",
    fill: "#F8F8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.75C15.5 11.1642 15.1642 11.5 14.75 11.5C14.3358 11.5 14 11.1642 14 10.75C14 10.3358 14.3358 10 14.75 10C15.1642 10 15.5 10.3358 15.5 10.75Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDetected);
export default __webpack_public_path__ + "static/media/AiDetected.b129167f9a02afe04302d212ba35aed4.svg";
export { ForwardRef as ReactComponent };